export default __webpack_public_path__ + "static/media/info2.1d3acde9.png";